export default __webpack_public_path__ + "static/media/oxford-small.77257812.png";